import { useCallback, useEffect, useState, useSyncExternalStore } from "react";

const STORAGE_KEY = "@ui:sidebar-collapsed";

// Mesmo recorte da decisão 4.5, que a sidebar compacta já usava em CSS: abaixo
// dele a largura da janela manda, e a preferência do usuário fica guardada.
const COMPACT_QUERY = "(max-width: 1100px)";

function subscribeToViewport(onChange) {
  const query = window.matchMedia(COMPACT_QUERY);

  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

function isNarrowViewport() {
  return window.matchMedia(COMPACT_QUERY).matches;
}

function storedPreference() {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

export function useSidebarCollapsed() {
  const [preference, setPreference] = useState(storedPreference);

  // useSyncExternalStore relê a média logo depois de assinar, e é isso que
  // salva o resize que acontece entre o primeiro render e a assinatura.
  const narrowViewport = useSyncExternalStore(subscribeToViewport, isNarrowViewport);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(preference));
  }, [preference]);

  const toggle = useCallback(() => setPreference((collapsed) => !collapsed), []);

  return {
    collapsed: narrowViewport || preference,
    canToggle: !narrowViewport,
    toggle,
  };
}
